import React from 'react';
import FormField from '../FormField';

export default function TransporteMobilidade() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual do transporte, da mobilidade e da infraestrutura viária no município.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="transporte_mobilidade_viaria_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual do transporte coletivo, intermunicipal, rural e escolar; ciclovias, calçadas, sinalização e segurança viária; rodovias, pavimentação, pontes e manutenção"
          helpText="Considere transporte coletivo, intermunicipal, rural e escolar; ciclovias, calçadas, sinalização e segurança viária; rodovias, pavimentação, pontes e manutenção"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="transporte_mobilidade_viaria_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe os principais indicadores encontrados, como linhas e localidades atendidas, frota, extensão de ciclovias, condição das calçadas, extensão da malha viária, trechos pavimentados e situação de pontes, sempre com ano e unidade de referência"
          helpText="Linhas e localidades atendidas, frota, extensão de ciclovias, condição das calçadas, extensão da malha viária, trechos pavimentados e situação de pontes, sempre com ano e unidade de referência"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="transporte_mobilidade_viaria_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados no transporte, na mobilidade e na infraestrutura viária"
          helpText="Principais problemas identificados no transporte, na mobilidade e na infraestrutura viária"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="transporte_mobilidade_viaria_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas para transporte público, mobilidade, acessibilidade, sinalização, pavimentação, pontes e manutenção viária"
          helpText="Considere transporte público, mobilidade, acessibilidade, sinalização, pavimentação, pontes e manutenção viária"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao5"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao5"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
